import { Injectable } from '@nestjs/common';
import { MulterFile } from '@webundsoehne/nest-fastify-file-upload';
import { extname, join } from 'path';
import { FastifyRequest } from 'fastify';
import { ConfigService } from '@nestjs/config';
import * as fs from 'fs/promises';

@Injectable()
export class UtilsService {
  constructor(private readonly configService: ConfigService) {}

  strSlug(string: string): string {
    return string
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[-]+/g, '-')
      .replace(/[^\w-]+/g, '');
  }

  baseUrl(req: FastifyRequest, path: string): string {
    const pathWithSlash = path.startsWith('/') ? path : `/${path}`;
    return `${req.protocol}://${req.hostname}${pathWithSlash}`;
  }

  createFileName(file: MulterFile): string {
    const name = this.strSlug(file.originalname.split('.')[0]);
    const extension = extname(file.originalname);
    const randomName = Array(32)
      .fill(null)
      .map(() => Math.round(Math.random() * 16).toString(16))
      .join('');
    return `${name}-${randomName}${extension}`;
  }

  async uploadFile(file: MulterFile): Promise<string> {
    const fileName = this.createFileName(file);
    const dir = this.configService.get<string>('config.storage.dir')!;
    const filePath = join(dir, fileName);
    const dirPath = join(process.cwd(), dir);
    try {
      await fs.mkdir(dirPath, { recursive: true });
    } catch (error) {}
    await fs.writeFile(join(dirPath, fileName), file.buffer);
    return filePath.replace(/\\/g, '/');
  }
}
